import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';
import AdminSidebar               from '../../components/admin/AdminSidebar';
import AdminHeader                from '../../components/admin/AdminHeader';
import DashboardOverview          from '../../components/admin/DashboardOverview';
import WorkflowManagement         from '../../components/admin/WorkflowManagement';
import InspectionsManagement      from '../../components/admin/InspectionsManagement';
import PricingManagement          from '../../components/admin/PricingManagement';
import CarsManagement             from '../../components/admin/CarsManagement';
import UsersManagement            from '../../components/admin/UsersManagement';
import SellRequestsManagement     from '../../components/admin/SellRequestsManagement';
import PaymentsManagement         from '../../components/admin/PaymentsManagement';
import PickupRequestsManagement   from '../../components/admin/PickupRequestsManagement';
import DeliveryRequestsManagement from '../../components/admin/DeliveryRequestsManagement';
import TestDriveManagement        from '../../components/admin/TestDriveManagement';
import DealerManagement           from '../../components/admin/DealerManagement';
import DealerCarListingsManagement from '../../components/admin/DealerCarListingsManagement';
import DealerPlanPaymentsPanel    from '../../components/admin/DealerPlanPaymentsPanel';
import ReviewsManagement          from '../../components/admin/ReviewsManagement'; // ✅ NEW

import '../../styles/AdminDashboard.css';
import '../../styles/WorkflowStyles.css';
import '../../styles/CarContentManagement.css';

const AdminDashboard = () => {
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();
  const [activeTab,   setActiveTab]   = useState('overview');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  const renderContent = () => {
    console.log('🔍 DEBUG activeTab:', activeTab); // TEMP — remove after confirming fix works
    switch (activeTab) {
      case 'overview':              return <DashboardOverview setActiveTab={setActiveTab} />;
      case 'workflow':              return <WorkflowManagement />;
      case 'inspections':           return <InspectionsManagement />;
      case 'pricing':               return <PricingManagement />;
      case 'cars':                  return <CarsManagement />;
      case 'users':                 return <UsersManagement />;
      case 'sell-requests':         return <SellRequestsManagement />;
      case 'payments':              return <PaymentsManagement />;
      case 'test-drives':           return <TestDriveManagement />;
      case 'pickup-requests':       return <PickupRequestsManagement />;
      case 'delivery-requests':     return <DeliveryRequestsManagement />;
      case 'dealer-management':     return <DealerManagement />;
      case 'dealer-car-listings':   return <DealerCarListingsManagement />;
      case 'dealer-plan-payments':  return <DealerPlanPaymentsPanel />;
      case 'reviews':               return <ReviewsManagement />;          // ✅ NEW
      default:                      return <DashboardOverview setActiveTab={setActiveTab} />;
    }
  };

  return (
    <div className="admin-dashboard">
      <AdminSidebar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
      />
      <div className="admin-main">
        <AdminHeader
          admin={admin}
          onLogout={handleLogout}
          onToggleSidebar={() => setSidebarOpen(prev => !prev)}
        />
        <div className="admin-content">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;